import {
  API_ERROR,
  DB_MAIN_DATA,
  DB_MAIN_DATA_SUCCESS
} from "./actionTypes";

export const getMainData = () => {
  return {
    type: DB_MAIN_DATA,
    payload: {  },
  };
};
export const getMainDataSuccessful = (response) => {
  return {
    type:  DB_MAIN_DATA_SUCCESS,
    payload: response,
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
